import { ExternalLink } from '@carvana/ds-icons';
import RatingStars from '@carvana/stc-rating-stars';

import {
  Background,
  StyledCarousel,
  CarouselHeader,
  Info,
  RatingContainer,
  StyledLink,
  Title,
  TotalRating
} from './CustomerReviews.styles';
import ReviewCard from './Review';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';
import { CarouselEventData } from 'analytics/uiMetrics';
import useCustomerReviews from 'shared/hooks/useCustomerReviews';

const CustomerReviews = () => {
  const { recordActionClicked, recordEventAndNavigate } = useAnalyticEvent();
  const { data: reviews } = useCustomerReviews();

  const handleSeeReviewsClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    recordEventAndNavigate(e, 'Landing Page', 'See all reviews');
  };

  const recordCarouselEvents = (data: CarouselEventData) => {
    recordActionClicked('Landing Page', 'Review carousel navigate', data);
  };

  return (
    <Background>
      {reviews && (
        <StyledCarousel
          headerContent={
            <CarouselHeader>
              <Title>What our customers are saying</Title>
              <Info>
                We've purchased more than 3 million cars from customers and received a lot of great
                feedback. See what’s behind our 4.8 star average rating.
              </Info>
              <RatingStars rating={5} />
              <RatingContainer>
                <TotalRating>4.8 stars</TotalRating> &nbsp;&nbsp;&nbsp;
                <StyledLink href="/reviews" onClick={handleSeeReviewsClick} preventVisitedColor>
                  See&nbsp;All&nbsp;Reviews&nbsp;
                  <ExternalLink size={16} color="currentColor" />
                </StyledLink>
              </RatingContainer>
            </CarouselHeader>
          }
          ariaLabel="customer-reviews"
          trackEvent={recordCarouselEvents}
          itemGap="sm"
          classes={{
            topSection: 'top-section',
            slides: 'slides',
            slide: 'slide'
          }}
        >
          {reviews.map(({ attributes: review }) => (
            <ReviewCard review={review} key={review.blurb} />
          ))}
        </StyledCarousel>
      )}
    </Background>
  );
};

export default CustomerReviews;
